<template>
    <component  
        :is="!isExternal && href ? 'router-link-component' : 'html-link-component'" 
        :href="href"
        :target="isExternal || newWindow ? '_blank' : '_self'"
        :active-class="activeClass"
        :exact-active-class="exactActiveClass">
        <slot></slot>
    </component>
</template>
<script>
import RouterLinkComponent from '#app#/components/common/LinkElements/RouterLink.vue'
import HtmlLinkComponent from '#app#/components/common/LinkElements/HtmlLink.vue'

export default {
    props: ['link', 'newWindow', 'classes', 'activeClass', 'exactActiveClass'],
    data() {
        return {
            isExternal: false,
            href: null,
        }
    },
    components: {
        RouterLinkComponent,
        HtmlLinkComponent,
    },
    created() {
        const domain = window.location.protocol + '//' + window.location.hostname;

        if (this.link.indexOf(domain) !== -1) {
            // Internal absolute
            this.isExternal = false;
            this.href = this.link.replace(domain, '');
        } else if(this.link.indexOf('http') === -1) {
            // Internal relative
            this.isExternal = false;
            this.href = this.link;
        } else {
            // External
            this.isExternal = true;
            this.href = this.link;
        }

        if(this.href == '//') {
            this.href = '/';
        }
    }
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/Link.vue